import React from 'react'

import Select from 'Components/Select'
import Input from 'Components/Input'
import Grid from '@material-ui/core/Grid'

export default React.memo(props => <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'center'}
                                         alignItems={'center'}>
  <Grid item xs={6} style={{ margin: 0, padding: 5 }}>
    <Select style={props.style} inline={props.inline} title={props.title}
            disabled={props.disabled || false}
            options={props.options} onChange={props.onChange}
            value={props.infoTiers === true && props.data !== undefined ? props.data.id : props.data}/>
  </Grid>
  <Grid item xs={6} style={{ margin: 0, padding: 5 }}>
    <Input
      type='number' style={{ width: '100%' }}
      disabled={props.disabled || false}
      onChange={props.onChangeInput}
      value={props.data !== undefined ? props.data.valeur_entier : props.data}/>
  </Grid>
</Grid>)


// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/Components/ComboSimpleEntier.js